import { createContext, PropsWithChildren, useContext, useState } from "react";
import { Mode } from "../types/Mode";

export interface ModeContextType {
  mode: Mode;
  transition: boolean;
  changeMode: (newMode: Mode, payload?: string) => void;
  setMode: (newMode: Mode) => void;
  navigationPayload?: string;
}

export const ModeContext = createContext<ModeContextType | null>(null);

export function ModeProvider({ children }: PropsWithChildren) {
  const [mode, setMode] = useState<Mode>(Mode.FIND);
  const [transition, setTransition] = useState(false);
  const [navigationPayload, setNavigationPayload] = useState<string | null>(null);

  function changeMode(newMode: Mode, payload?: string) {
    if (newMode === mode) return;
    // setTransition(true);
    // setTimeout(() => {
    if (payload) setNavigationPayload(payload);
    else setNavigationPayload(null);
    setMode(newMode);
    // setTransition(false);
    // }, 250);
  }

  const value: ModeContextType = {
    mode,
    transition,
    changeMode,
    setMode,
    navigationPayload: navigationPayload ?? undefined
  };

  return <ModeContext.Provider value={value}>{children}</ModeContext.Provider>;
}

export function useMode() {
  const ctx = useContext(ModeContext);
  if (!ctx) throw new Error("useMode must be used inside ModeProvider");
  return ctx;
}
